<template>
  <modal ref='modal' class="filter-all-records">
    <template #header>
      <h5 class='modal-title mt-0'>
        {{ $t('shared.filter') }}
      </h5>
    </template>

    <template #body>
      <form @submit.prevent='filter()'>
        <div class='modal-body'>
          <div class='form-group form-inline'>
            <label>{{ $t('root.filters.show_only') }}</label>

            <label>
              <input type='radio' v-model='filters.klass' value='Record'>
              {{ $t('root.filters.files') }}
            </label>

            <label>
              <input type='radio' v-model='filters.klass' value='Folder'>
              {{ $t('root.filters.folders') }}
            </label>

            <label>
              <i class='fas fa-times' :title="$t('records_list.remove_selection')" @click.prevent='filters.klass = null'></i>
            </label>
          </div>

          <div class='form-group form-inline'>
            <label>{{ $t('folders_list.subscribed_folders') }}</label>

            <label>
              <input type='radio' v-model='filters.subscribed' value='true'>
              {{ $t('folders_list.yes_way') }}
            </label>

            <label>
              <input type='radio' v-model='filters.subscribed' value='false'>
              {{ $t('folders_list.no_way') }}
            </label>

            <label>
              <i class='fas fa-times' :title="$t('records_list.remove_selection')" @click.prevent='filters.subscribed = null'></i>
            </label>
          </div>

          <div class='form-group form-inline'>
            <label>{{ $t('folders_list.belongs') }}</label>

            <label>
              <input type='radio' v-model='filters.checklist' value='true'>
              {{ $t('folders_list.yes_way') }}
            </label>

            <label>
              <input type='radio' v-model='filters.checklist' value='false'>
              {{ $t('folders_list.no_way') }}
            </label>

            <label>
              <i class='fas fa-times' :title="$t('records_list.remove_selection')" @click.prevent='filters.checklist = null'></i>
            </label>
          </div>

          <div class='form-group form-inline'>
            <label>{{ $t('folders_list.starred_files') }}</label>

            <label>
              <input type='radio' v-model='filters.starred' value='true'>
              {{ $t('folders_list.yes_way') }}
            </label>

            <label>
              <input type='radio' v-model='filters.starred' value='false'>
              {{ $t('folders_list.no_way') }}
            </label>

            <label>
              <i class='fas fa-times' :title="$t('records_list.remove_selection')" @click.prevent='filters.starred = null'></i>
            </label>
          </div>

          <div class='form-group form-inline'>
            <label>{{ $t('folders_list.shared_files') }}</label>

            <label>
              <input type='radio' v-model='filters.shared' value='true'>
              {{ $t('folders_list.yes_way') }}
            </label>

            <label>
              <input type='radio' v-model='filters.shared' value='false'>
              {{ $t('folders_list.no_way') }}
            </label>

            <label>
              <i class='fas fa-times' :title="$t('records_list.remove_selection')" @click.prevent='filters.shared = null'></i>
            </label>
          </div>

          <div class='form-group'>
            <label>
              {{ $t('folders_list.contacts') }}
            </label>

            <multi-select v-model='filters.contacts' :options='contacts' />
          </div>

          <div class='form-group'>
            <label>
              {{ $t('folders_list.filter_by_tags') }}
            </label>

            <multi-select v-model='filters.tags' :options='tags' />
          </div>

          <div class='form-group'>
            <label>
              {{ $t('folders_list.expiration_status') }}
            </label>

            <multi-select v-model='filters.status' :options='expStatus' />
          </div>
        </div>

        <div class='modal-footer'>
          <input type='reset' class='btn btn-neutral float-right' :value="$t('folders_list.clear_filters')" @click.prevent='reset' />
          <input type='submit' class='btn btn-outline-primary float-right' :value="$t('folders_list.filter')" />
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
  import _modal from '../../_modal'
  import _multi_select from '../_multi_select'

  const DEFAULT_FILTERS = {
    tags: [],
    status: [],
    contacts: [],
    klass: null,
    shared: null,
    starred: null,
    checklist: null,
  }

  export default {
    components: {
      modal: _modal,
      'multi-select': _multi_select
    },
    created() {
      this.filters = Object.assign({}, DEFAULT_FILTERS)
    },
    data() {
      return {
        filters: {}
      }
    },
    computed: {
      contacts() {
        return this.lists.contacts || []
      },
      tags() {
        return this.lists.tags || []
      },
      compactedFilters() {
        let res = {}

        Object.entries(this.filters).forEach(([k, v]) => {
          if (Array.isArray(v) ? v.length > 0 : v)
            res[k] = v
        })

        return res
      },
      expStatus() {
        return [
          { id: 'soon', name: this.$t('calendar.soon_files') },
          { id: 'current', name: this.$t('calendar.current_files') },
          { id: 'expired', name: this.$t('calendar.expired_files') },
          { id: 'no_expiration', name: this.$t('calendar.no-date') },
        ]
      }
    },
    methods: {
      open() {
        const promises = [
          this.listStore.getContacts(),
          this.listStore.getTags(),
        ]

        Promise.allSettled(promises).then(() => {
          this.$refs.modal.open()
        })
      },
      close() {
        this.$refs.modal.close()
      },
      reset() {
        this.filters = Object.assign({}, DEFAULT_FILTERS)
        this.$emit('reset')
        this.$refs.modal.close()
      },
      filter() {
        if (Object.keys(this.compactedFilters).length > 0)
          this.$emit('filter', this.compactedFilters)

        this.$refs.modal.close()
      },
    }
  }
</script>
<style lang="sass" scoped>
.filter-all-records
  form
    text-align: left
    label
      text-align: left
      display: block
    .form-group
      margin-bottom: 20px
    .form-inline
      label
        width: 20%
        &:first-child
          width: 50%
        &:last-child
          width: 5%
          color: #686868
          cursor: pointer
</style>
